import { AnalyticsStore, PageStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClientLogger } from 'bernie-client';

import { Map, PropertyDetailsMap } from '@shared-ui/lodging-property-details';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { MapStore } from 'src/common/stores/map-store';

import { INFOSITE_PAGE_EG_CLICKSTREAM_NAME, InfositePageEgClickstreamDetailedName, InfositePageName } from 'constants/pages';

import { EssClientLogger } from 'typeahead-client-logger';
import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const APP_NAME = 'shopping-pwa';
const APP_VERSION = '1.0.1';

interface MapProps extends SharedUiWrapperProps {
  onClose: () => void;
  page?: PageStore;
  map?: MapStore;
  analytics?: AnalyticsStore;
}

const getDetailedPageName = (uisPageName: string): string => {
  switch (uisPageName) {
    case InfositePageName.SA:
      return InfositePageEgClickstreamDetailedName.SA;
    case InfositePageName.FH:
      return InfositePageEgClickstreamDetailedName.FH;
    case InfositePageName.HC:
      return InfositePageEgClickstreamDetailedName.HC;
    case InfositePageName.FHC:
      return InfositePageEgClickstreamDetailedName.FHC;
    default:
      return InfositePageEgClickstreamDetailedName.SA;
  }
};

const PropertyMap: React.FC<MapProps> = inject(
  'page',
  'map',
  'analytics'
)(
  observer(({ inputs, onClose, page, map, analytics }) => {
    const { reset } = useClickstreamAnalytics();
    const triggerRef = React.useRef(null);

    const pageName = page?.pageName || InfositePageName.SA;
    const detailedEgClickstreamName = getDetailedPageName(pageName);
    reset({
      data: {
        experience: {
          // eslint-disable-next-line camelcase
          app_name: APP_NAME,
          // eslint-disable-next-line camelcase
          app_version: APP_VERSION,
          // eslint-disable-next-line camelcase
          page_name: INFOSITE_PAGE_EG_CLICKSTREAM_NAME,
          // eslint-disable-next-line camelcase
          page_name_detailed: detailedEgClickstreamName,
        },
      },
      config: {
        isEgClickstream: true,
      },
    });

    const setSavedFeature = map ? (customPlace: any) => map.setCustomPlace(customPlace) : undefined;
    const savedFeature = map?.customPlaces?.[0];
    const essLogger = new EssClientLogger(analytics, ClientLogger, '');

    const mapProps = {
      inputs,
      onClose,
      setSavedFeature,
      savedFeature,
      essLogger,
      triggerRef,
    };

    return (
      <div className="uitk-dialog-layer shared-ui-map" data-stid="infosite-map">
        <Experiment name="EG_Maps_PDP_schema_update">
          <ExperimentControl>
            <PropertyDetailsMap {...mapProps} />
          </ExperimentControl>
          <ExperimentVariant bucket={1}>
            <Map {...mapProps} />
          </ExperimentVariant>
        </Experiment>
      </div>
    );
  })
);

export const SharedUiMap = withSharedUiPropertyDetails<Omit<MapProps, 'inputs'>>(PropertyMap);
SharedUiMap.displayName = 'SharedUiMap';
